import React, { useState } from "react";
import {
    Paper,
    Typography,
    Box,
    Tabs,
    Tab,
    Container
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import GavelIcon from "@mui/icons-material/Gavel";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import BusinessIcon from "@mui/icons-material/Business";
import AthletesManagementPage from "./AthletesManagementPage";
import JudgesManagementPage from "./JudgesManagementPage";
import OfficialsManagementPage from "./OfficialsManagementPage";
import ProfilePage from "./ProfilePage";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`club-management-tabpanel-${index}`}
            aria-labelledby={`club-management-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && (
                <Box sx={{ p: 3, width: '100%' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `club-management-tab-${index}`,
        'aria-controls': `club-management-tabpanel-${index}`,
    };
}

const ClubManagementPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ width: '100%', mt: 3 }}>
                <Typography variant="h4" gutterBottom sx={{ p: 2 }}>
                    Vereinsverwaltung
                </Typography>

                <Paper elevation={3} sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
                        <Tabs 
                            value={activeTab} 
                            onChange={handleTabChange} 
                            aria-label="club management tabs"
                            variant="fullWidth"
                            indicatorColor="primary"
                            textColor="primary"
                            sx={{ 
                                width: '100%',
                                '& .MuiTabs-flexContainer': {
                                    justifyContent: 'space-between',
                                    width: '100%'
                                },
                                '& .MuiTab-root': {
                                    flexGrow: 1,
                                    maxWidth: 'none'
                                }
                            }}
                        >
                            <Tab icon={<PersonIcon />} label="Sportler" {...a11yProps(0)} />
                            <Tab icon={<GavelIcon />} label="Kampfrichter" {...a11yProps(1)} />
                            <Tab icon={<SupervisorAccountIcon />} label="Offizielle" {...a11yProps(2)} />
                            <Tab icon={<BusinessIcon />} label="Verein verwalten" {...a11yProps(3)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={activeTab} index={0}>
                        <AthletesManagementPage />
                    </TabPanel>

                    <TabPanel value={activeTab} index={1}>
                        <JudgesManagementPage />
                    </TabPanel>

                    <TabPanel value={activeTab} index={2}>
                        <OfficialsManagementPage />
                    </TabPanel>

                    <TabPanel value={activeTab} index={3}>
                        <ProfilePage />
                    </TabPanel>
                </Paper>
            </Box>
        </Container>
    );
};

export default ClubManagementPage;